import React from "react";
import PropTypes from "prop-types";
import "./index.css";

const DOTS = [0, 1, 2, 3, 4, 5, 6, 7];

const LoadingSpinner = ({ size = 36 }) => {
    const style = size !== 36 ? { "--loading-spinner-size": `${size}px` } : undefined;
    return (
        <div className="loading-spinner" role="status" aria-label="Loading" style={style}>
            {DOTS.map((index) => (
                <span
                    key={index}
                    className="loading-spinner__dot"
                    style={{ "--i": index }}
                />
            ))}
        </div>
    );
};

LoadingSpinner.propTypes = {
    size: PropTypes.number,
};

export default LoadingSpinner;
